/** @format */

import axios from "axios";
// import alertify from "alertifyjs";
import { getAlert } from "../../util/alert";
import Constantes from "../../util/Constantes";

const SERVER = process.env.REACT_APP_SERVER_URL_UPNCORE;
const PATH_LOCATIONPaid = Constantes().ApiConfig.PATH_FinancesPaid;
const PATH_LOCATIONVisaSync = Constantes().ApiConfig.PATH_FinancesVisaSync;
const PATH_LOCATIONDebts = Constantes().ApiConfig.PATH_FinancesDebts;
const ENDPOINTPaid = `${SERVER}${PATH_LOCATIONPaid}`;
const ENDPOINTVisaSync = `${SERVER}${PATH_LOCATIONVisaSync}`;
const ENDPOINTDebts = `${SERVER}${PATH_LOCATIONDebts}`;
const headers = Constantes().ApiConfig.headers;
const dataUser = JSON.parse(localStorage.getItem("userLogin"));
const API = {
  listarPaid: async (codigo, alertMessage) => {
    try {
      let result = await axios.get(`${ENDPOINTPaid}${codigo}`, {
        headers: headers,
      });
      if (dataUser == undefined) {
        getAlert(
          Constantes().msmObligaciones,
          Constantes().login,
          alertMessage
        );
      } else if (result.data.Status == "NOK") {
        getAlert(result.data.message, "", alertMessage);
      } else if (result.data.detail.length == 0) {
        getAlert(Constantes().msmObligaciones, "", alertMessage);
      }
      return await result.data.detail;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },
  listarVisaSync: async (codigo, alertMessage) => {
    try {
      let result = await axios.get(`${ENDPOINTVisaSync}${codigo}`, {
        headers: headers,
      });
      if (dataUser == undefined) {
        getAlert(Constantes().msmSincronizar, Constantes().login, alertMessage);
      } else if (result.data.Status == "NOK") {
        getAlert(result.data.message + "sadadas", "", alertMessage);
      } else if (result.data.detail.length == 0) {
        getAlert(Constantes().msmSincronizar, "", alertMessage);
      }
      return await result.data.detail;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },
  listarDebts: async (codigo, alertMessage) => {
    try {
      let result = await axios.get(`${ENDPOINTDebts}${codigo}`, {
        headers: headers,
      });
      if (dataUser == undefined) {
        getAlert(Constantes().msmPagar, Constantes().login, alertMessage);
      } else if (result.data.Status == "NOK") {
        getAlert(result.data.message, "", alertMessage);
      } else if (result.data.detail.length == 0) {
        getAlert(Constantes().msmPagar, "", alertMessage);
      }
      return await result.data.detail;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },
};

export default API;
